class AuctionViewer {
    constructor() {
        this.modalSelector = '.auction_creation_popup';

        console.log('AuctionViewer');
        document.getElementById('auctionModalOpener').addEventListener('click', (e)=> {
            $.ajax({
                url: '/ajaxRequest/creation/getAutcionCreationData',
                type: 'POST',
                dataType: 'json',
                data: {
                    auction_id: e.currentTarget.dataset.auctionId,
                    lastId: e.currentTarget.dataset.lastId
                },
                success: (response) => {
                    console.log(response);
                    this.reloadModal(response.data.html);
                    this.initModal();
                    this.showModal();
                }
            });
        });
    }

    initModal() {
        document.querySelectorAll('.loadCreation').forEach((item) => {
            item.addEventListener('click', this.loadCreation.bind(this));
        });
    }

    reloadModal(contentHtml) {
        let oldModal =  $(this.modalSelector);
        if(oldModal.length) {
            $('.modal-backdrop').remove();
            oldModal.remove();
        }

        document.body.insertAdjacentHTML('beforeend', contentHtml);

        $('.auction_creation_popup [data-toggle="tooltip"]').tooltip();

        let modal = $(this.modalSelector);
        modal.on('hidden.bs.modal',  (e) => {
            modal.modal('dispose');
            modal.remove();
        });
    }

    showModal() {
        $(this.modalSelector).modal('show');
    }

    loadCreation(e) {
        console.log(e.currentTarget);
        let btn = e.currentTarget;

        $.ajax({
            url: '/ajaxRequest/creation/getNeighbourCreationLot',
            type: 'POST',
            dataType: 'json',
            data: {
                au_cr_id: btn.dataset.id,
                direction: btn.dataset.direction
            },
            success: (response) => {
                console.log(response);
                //init modal, open modal
                this.reloadModal(response.data.html);
                this.initModal();
                this.showModal();

                document.getElementById('auctionModalOpener').dataset.lastId = response.data.creation_id;
            }
        });
    }
}

document.addEventListener('DOMContentLoaded',() => {
    new AuctionViewer();
});